import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import secureStorage from "../../../../../services/secureStorage";
import {
  colorBlack,
  colorLightGrey,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import {
  SS_ADMIN_ID,
  SS_AUTH_TOKEN,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  CLIENT,
  FLAT,
  RESELLER,
  SALES,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomSelect from "../../../../components/main_comps/custom_select";
import CheckBoxInput, {
  SerivceProviderDropdown,
} from "../../../../components/ui_comps/CheckBoxInput";
import ComissionContainer, {
  checkObjHasAllValue,
} from "../../../../components/ui_comps/ComissionContainer";
import RowButton from "../../../../components/ui_comps/RowButton";

export const formDataPush = (data) => {
  const formdata = new FormData();
  Object.keys(data).map((val, i) => {
    formdata.append(val, data[val]);
  });

  return formdata;
};
function ResellerDetails({ onClickBack, onSuccess, reduxData }) {
  const [resellerName, setResellerName] = useState("");
  const [clientRate, setClientRate] = useState("");
  const [resellerRate, setResellerRate] = useState("");
  const [neokredRate, setNeokredRate] = useState("");
  const [serviceType, setServiceType] = useState([]);
  const [service, setService] = useState([]);
  const clientData = useSelector((state) => state.onboardClientSlice);
  const [serviceDetails1, setServiceDetails1] = useState({});
  const [serviceDropdownValue, setServiceDropdownValue] = useState({});
  const [serviceDropdownValue1, setServiceDropdownValue1] = useState({});
  const [serviceDetails2, setServiceDetails2] = useState({});
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [createdBy, setCreatedBy] = useState({});
  const [validateUrl1, setValidateUrl1] = useState("");
  const [validateUrl2, setValidateUrl2] = useState("");

  const [commissionRate, setCommissionRate] = useState([]);
  const [flatData, setFlatData] = useState([]);
  const [type, setType] = useState([]);
  const [resellerData, setResellerData] = useState([]);
  const [serviceProviderNameList, setServiceProviderNameList] = useState([]);
  const [resellerDetails, setResellerDetails] = useState("");
  const [adminId, setAdminId] = useState("");
  const [loading, setLoading] = useState(false);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 10,
  };

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px",
  };

  const { enqueueSnackbar } = useSnackbar();
  const alterArrays = (val) => {
    if (serviceType.includes(val)) {
      let filteredData = serviceType.filter((vals, i) => vals !== val);
      setServiceType(filteredData);
      if (filteredData[0] === "payin") {
        setService([
          {
            serviceType: filteredData[0],
            ...serviceDetails1,
          },
        ]);
        setServiceDetails2({});
        setServiceDropdownValue1({});
      } else {
        setService([
          {
            serviceType: filteredData[0],
            ...serviceDetails2,
          },
        ]);
        setServiceDetails1({});
        setServiceDropdownValue({});
      }
    } else {
      setServiceType([...serviceType, val]);
      if (val === "payin") {
        setService([
          ...service,
          {
            serviceType: val,
            ...serviceDetails1,
          },
        ]);
      } else {
        setService([
          ...service,
          {
            serviceType: val,
            ...serviceDetails2,
          },
        ]);
      }
    }
  };

  const onClickAddClient = (data) => {
    setLoading(true);

    const formdata = formDataPush({ ...clientData, ...data });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "client/create", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const updateValues = (type) => {
    const datas = service.map((obj, i) => {
      if (obj["serviceType"] === "payin") {
        return { ...obj, ...serviceDetails1 };
      } else if (obj["serviceType"] === "payout") {
        return { ...obj, ...serviceDetails2 };
      }
      return obj;
    });
    setService([...datas]);
  };

  useEffect(() => {
    if (serviceType.length === 0) {
      setService([]);
    }
  }, [serviceType]);

  useEffect(() => {
    if (
      serviceDetails1["serviceProviderName"] &&
      serviceDetails1["serviceProviderRate"]
    ) {
      updateValues("payin");
    }
  }, [serviceDetails1]);

  useEffect(() => {
    if (
      serviceDetails2["serviceProviderName"] &&
      serviceDetails2["serviceProviderRate"]
    ) {
      updateValues("payout");
    }
  }, [serviceDetails2]);

  const getData = async () => {
    const id = await secureStorage.getItem(SS_USER_HASH_ID);
    const role = await secureStorage.getItem(SS_ROLE);
    const firstName = await secureStorage.getItem(SS_FIRST_NAME);
    const lastName = await secureStorage.getItem(SS_LAST_NAME);
    const email = await secureStorage.getItem(SS_EMAIL);
    const adminid = await secureStorage.getItem(SS_ADMIN_ID);
    setCreatedBy({ email, userName: firstName + " " + lastName });

    if (role?.toLocaleUpperCase() === RESELLER) {
      setResellerName(firstName + " " + lastName);
      setAdminId(adminid);
    }
    setUserId(id);
    setRole(role);
  };

  const modififyDropdownData = (data) => {
    let arr = [
      {
        label: "Select Reseller",
        value: "",
        commissionRate: "",
        commissionType: "",
        userRefId: "",
      },
    ];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.userId,
          label: val.firstName + " " + val.lastName,
          commissionRate: val?.comissionRate,
          commissionType: val?.comissionType,
          userRefId: val?.userRefId,
        });
      });

    return arr;
  };

  const modififyDropdownServiceNameList = (data, res) => {
    let arr = [res];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.serviceProviderRate,
          label: val.serviceProviderName,
        });
      });

    return arr;
  };

  const getResellerList = () => {
    ApiRequestGet.getResellerList()
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setResellerData(modififyDropdownData(res.data));
        }
      })
      .catch((err) => {});
  };

  const getServiceProviderList = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          let data1 = { label: "Select Service Provider Name", value: "" };
          setServiceProviderNameList(
            modififyDropdownServiceNameList(res.data, data1)
          );
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getData();
    getResellerList();
    getServiceProviderList();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          overflow: "auto",
          maxHeight: 600,
        }}
        className="hide-scroll-bar"
      >
        {role?.toUpperCase() !== CLIENT && role?.toUpperCase() !== RESELLER ? (
          <div>
            <p style={textStyle}>Select Reseller Name</p>
            <CustomSelect
              value={resellerDetails}
              onChange={(data) => {
                setResellerDetails(data);
              }}
              options={resellerData}
            />
          </div>
        ) : (
          <div>
            <p style={textStyle}>Reseller Name</p>
            <CustomInput
              value={resellerName}
              // onChange={(data) => setResellerName(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Reseller name"
              validator="name"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
              disabled={true}
            />
          </div>
        )}
        <div>
          <p style={textStyle}>Client rate</p>
          <CustomInput
            value={clientRate}
            onChange={(data) => setClientRate(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Client rate"
            validator="paise"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div>
          <p style={textStyle}>Reseller rate</p>
          <CustomInput
            value={resellerRate}
            onChange={(data) => setResellerRate(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Reseller rate"
            validator="paise"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div>
          <p style={textStyle}>Neokred rate</p>
          <CustomInput
            value={neokredRate}
            onChange={(data) => setNeokredRate(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Neokred rate"
            validator="paise"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div>
          <p style={textStyle}>Client comission</p>
          <ComissionContainer
            onClickNext={(data, flatData, type) => {
              setCommissionRate(data);
              setFlatData(flatData);
              setType(type?.toUpperCase());
            }}
            isSlabRequired={true}
          />
        </div>
        <div>
          <p style={textStyle}>Service Type</p>
          <CheckBoxInput
            title="Pay In"
            value={"payin"}
            onChange={(val) => {
              alterArrays(val.target.value);
            }}
          />

          {serviceType.includes("payin") && (
            <>
              <div
                style={{
                  width: "100%",
                  backgroundColor: colorLightGrey,
                  padding: "10px 15px",
                  marginBottom: 5,
                }}
              >
                <SerivceProviderDropdown
                  onChange1={(val) => {
                    if (val.label?.toLowerCase() !== "kopay") {
                      setServiceDetails1({
                        ...serviceDetails1,
                        merchantId: "",
                        cidNumber: "",
                        serviceProviderName: val.label,
                        serviceProviderRate: val.value,
                        clientUpiId: "",
                      });
                    } else {
                      setServiceDetails1({
                        ...serviceDetails1,
                        serviceProviderName: val.label,
                        serviceProviderRate: val.value,
                      });
                    }

                    setServiceDropdownValue(val);
                  }}
                  serviceProviderNameList={serviceProviderNameList}
                  rateValue={serviceDetails1.serviceProviderRate}
                  value1={serviceDropdownValue}
                />
                {serviceDetails1.serviceProviderName?.toLowerCase() ===
                  "kopay" && (
                  <>
                    <div>
                      <p
                        style={{
                          ...textStyle,
                          color: "black",
                          fontSize: 13,
                          fontWeight: "500",
                        }}
                      >
                        CID Number
                      </p>
                      <CustomInput
                        value={serviceDetails1.cidNumber}
                        onChange={(data) => {
                          setServiceDetails1({
                            ...serviceDetails1,
                            cidNumber: data,
                          });
                        }}
                        inputcomponentStyles={{
                          ...inputStyle,
                          backgroundColor: "white",
                          borderRadius: 4,
                        }}
                        placeholder="Cid"
                        validator="alphaNum"
                        type="input"
                        inputStyles={{
                          ...containerStyle,
                        }}
                      />
                    </div>

                    <div>
                      <p
                        style={{
                          ...textStyle,
                          color: "black",
                          fontSize: 13,
                          fontWeight: "500",
                        }}
                      >
                        Client UPI Id
                      </p>
                      <CustomInput
                        value={serviceDetails1.clientUpiId}
                        onChange={(data) => {
                          setServiceDetails1({
                            ...serviceDetails1,
                            clientUpiId: data,
                          });
                        }}
                        inputcomponentStyles={{
                          ...inputStyle,
                          backgroundColor: "white",
                          borderRadius: 4,
                        }}
                        placeholder="Client Upi Id"
                        validator=""
                        type="input"
                        inputStyles={{
                          ...containerStyle,
                        }}
                      />
                    </div>

                    <div>
                      <p
                        style={{
                          ...textStyle,
                          color: "black",
                          fontSize: 13,
                          fontWeight: "500",
                        }}
                      >
                        Merchant ID
                      </p>
                      <CustomInput
                        value={serviceDetails1.merchantId}
                        onChange={(data) => {
                          setServiceDetails1({
                            ...serviceDetails1,
                            merchantId: data,
                          });
                        }}
                        inputcomponentStyles={{
                          ...inputStyle,
                          backgroundColor: "white",
                          borderRadius: 4,
                        }}
                        placeholder="Merchant Id"
                        type="input"
                        inputStyles={{
                          ...containerStyle,
                        }}
                      />
                    </div>
                  </>
                )}
                <div>
                  <p style={textStyle}>Notify Url</p>
                  <CustomInput
                    value={serviceDetails1.notifyUrl}
                    onChange={(data) => {
                      setServiceDetails1({
                        ...serviceDetails1,
                        notifyUrl: data,
                      });
                    }}
                    inputcomponentStyles={{
                      ...inputStyle,
                      backgroundColor: "white",
                      borderRadius: 4,
                    }}
                    placeholder="Notify Url"
                    validator="url"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>

                <div>
                  <p style={textStyle}>Validate Url</p>
                  <CustomInput
                    value={serviceDetails1?.validateUrl}
                    onChange={(data) => {
                      // setValidateUrl1(data);
                      setServiceDetails1({
                        ...serviceDetails1,
                        validateUrl: data,
                      });
                    }}
                    inputcomponentStyles={{
                      ...inputStyle,
                      backgroundColor: "white",
                      borderRadius: 4,
                    }}
                    placeholder="Validate Url"
                    validator="url"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div
          style={{
            marginTop: 15,
          }}
        >
          <CheckBoxInput
            title="Pay Out"
            value={"payout"}
            onChange={(val) => {
              alterArrays(val.target.value);
            }}
          />

          {serviceType.includes("payout") && (
            <div
              style={{
                width: "100%",
                backgroundColor: colorLightGrey,
                padding: "10px 15px",
                marginBottom: 5,
              }}
            >
              <SerivceProviderDropdown
                onChange1={(val) => {
                  setServiceDetails2({
                    serviceProviderName: val.label,
                    serviceProviderRate: val.value,
                  });
                  setServiceDropdownValue1(val);
                }}
                serviceProviderNameList={serviceProviderNameList}
                rateValue={serviceDetails2.serviceProviderRate}
                value1={serviceDropdownValue1}
              />
              <div>
                <p style={textStyle}>Notify Url</p>
                <CustomInput
                  value={serviceDetails2.notifyUrl}
                  onChange={(data) => {
                    setServiceDetails2({
                      ...serviceDetails2,
                      notifyUrl: data,
                    });
                  }}
                  inputcomponentStyles={{
                    ...inputStyle,
                    backgroundColor: "white",
                    borderRadius: 4,
                  }}
                  placeholder="Notify Url"
                  validator="url"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
              <div>
                <p style={textStyle}>Validate Url</p>
                <CustomInput
                  value={serviceDetails2?.validateUrl}
                  onChange={(data) => {
                    setServiceDetails2({
                      ...serviceDetails2,
                      validateUrl: data,
                    });
                  }}
                  inputcomponentStyles={{
                    ...inputStyle,
                    backgroundColor: "white",
                    borderRadius: 4,
                  }}
                  placeholder="Validate Url"
                  validator="url"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          let checkObj1 = {};
          let checkObj2 = {};
          if (serviceDetails1.serviceProviderName?.toLowerCase() === "kopay") {
            checkObj1 = {
              notifyUrl: serviceDetails1.notifyUrl,
              serviceProviderName: serviceDetails1.serviceProviderName,
              serviceProviderRate: serviceDetails1.serviceProviderRate,
              serviceType: "payin",
              cidNumber: serviceDetails1.cidNumber,
              merchantId: serviceDetails1.merchantId,
              clientUpiId: serviceDetails1.clientUpiId,
            };
          } else {
            checkObj1 = {
              notifyUrl: serviceDetails1.notifyUrl,
              serviceProviderName: serviceDetails1.serviceProviderName,
              serviceProviderRate: serviceDetails1.serviceProviderRate,
              serviceType: "payin",
            };
          }

          checkObj2 = {
            notifyUrl: serviceDetails2.notifyUrl,
            serviceProviderName: serviceDetails2.serviceProviderName,
            serviceProviderRate: serviceDetails2.serviceProviderRate,
            serviceType: "payout",
          };

          if (
            checkObjHasAllValue({
              clientRate,
              resellerRate,
              neokredRate,
              resellerId:
                role?.toUpperCase() === ADMIN ? resellerDetails?.value : "jjjj",
            }) &&
            serviceType.length !== 0 &&
            (serviceType.length === 1
              ? checkObjHasAllValue({ ...checkObj1 }) ||
                checkObjHasAllValue({ ...checkObj2 })
              : checkObjHasAllValue({ ...checkObj1 }) &&
                checkObjHasAllValue({ ...checkObj2 })) &&
            (type === FLAT
              ? checkObjHasAllValue({
                  ...flatData,
                })
              : checkObjHasAllValue({
                  ...commissionRate,
                }))
          ) {
            let obj = [];
            if (type === FLAT) {
              obj.push(flatData);
            } else {
              obj.push(...commissionRate);
            }

            onClickAddClient({
              userRefId:
                role?.toUpperCase() !== CLIENT &&
                role?.toUpperCase() !== RESELLER
                  ? resellerDetails?.value
                  : userId,
              resellerName:
                role?.toUpperCase() !== CLIENT &&
                role?.toUpperCase() !== RESELLER
                  ? resellerDetails?.label
                  : resellerName,
              rootReferenceId:
                role?.toUpperCase() !== CLIENT &&
                role?.toUpperCase() !== RESELLER
                  ? resellerDetails?.userRefId
                  : adminId,
              clientRate,
              resellerRate,
              neokredRate,
              service: JSON.stringify(service),
              role,
              createdBy: JSON.stringify(createdBy),
              comissionType: type,
              comissionRate: JSON.stringify([...obj]),

              // rootReferenceId
            });
          } else {
            enqueueSnackbar("Please fill all the fields", {
              variant: "error",
            });
          }
        }}
        loading={loading}
      />
    </div>
  );
}

export default ResellerDetails;
